(function () {
  'use strict';

  if (window.PGHomePolishV33) return;
  window.PGHomePolishV33 = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function dismissCue(cue) {
    if (!cue || cue.classList.contains('is-dismissed')) return;
    cue.classList.add('is-dismissed');
    window.setTimeout(function () {
      cue.setAttribute('aria-hidden', 'true');
    }, reduceMotion ? 0 : 380);
  }

  function initLikenessSlider(root) {
    if (!root || root.dataset.pgV33Ready === 'true') return;

    var rail = root.querySelector('[data-pg-likeness-rail]');
    var slides = rail ? Array.prototype.slice.call(rail.querySelectorAll('.pg-likeness-compare__slide')) : [];
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pg-likeness-dots] button'));
    var cue = root.querySelector('[data-pg-swipe-cue]');
    if (!rail || slides.length < 2) return;

    root.dataset.pgV33Ready = 'true';
    var frame = null;
    var interacted = false;

    function nearestIndex() {
      var best = 0;
      var bestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.offsetLeft - rail.scrollLeft);
        if (distance < bestDistance) {
          best = index;
          bestDistance = distance;
        }
      });
      return best;
    }

    function updateDots() {
      frame = null;
      var active = nearestIndex();
      dots.forEach(function (dot, index) {
        var selected = index === active;
        dot.classList.toggle('is-active', selected);
        if (selected) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function onScroll() {
      if (!frame) frame = window.requestAnimationFrame(updateDots);
      if (interacted) dismissCue(cue);
    }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (eventName) {
      rail.addEventListener(eventName, function () {
        interacted = true;
        dismissCue(cue);
      }, { passive: true });
    });

    rail.addEventListener('scroll', onScroll, { passive: true });
    rail.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      interacted = true;
      dismissCue(cue);
      var next = nearestIndex() + (event.key === 'ArrowRight' ? 1 : -1);
      next = Math.max(0, Math.min(slides.length - 1, next));
      rail.scrollTo({ left: slides[next].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        interacted = true;
        dismissCue(cue);
        rail.scrollTo({ left: slides[index].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });

    updateDots();
  }

  function initShelfCue() {
    var shelf = document.querySelector('[data-pg-home-shelf]');
    if (!shelf || shelf.dataset.pgV33CueReady === 'true') return;

    var railWrap = shelf.querySelector('.pg-home-shelf__rail-wrap');
    var rail = shelf.querySelector('.pg-home-shelf__rail');
    if (!railWrap || !rail) return;

    shelf.dataset.pgV33CueReady = 'true';
    var cue = document.createElement('p');
    cue.className = 'pg-swipe-cue pg-swipe-cue--shelf';
    cue.innerHTML = 'Go on... swipe through the favourites <span class="pg-swipe-cue__arrow" aria-hidden="true">&rarr;</span>';
    railWrap.parentNode.insertBefore(cue, railWrap);

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (eventName) {
      rail.addEventListener(eventName, function () { dismissCue(cue); }, { passive: true, once: true });
    });
    rail.addEventListener('scroll', function () {
      if (rail.scrollLeft > 8) dismissCue(cue);
    }, { passive: true });
  }

  function initReveals() {
    var selectors = [
      '.pg-home-shelf-host',
      '.pg-likeness-compare[data-pg-likeness-slider]',
      '.pg-style-shop',
      '.pg-njp',
      '.pg-review-gallery',
      '.pg-why-choose-section',
      '.pg-faq'
    ];
    var nodes = Array.prototype.slice.call(document.querySelectorAll(selectors.join(',')));
    if (!nodes.length) return;

    document.documentElement.classList.add('pg-v33-motion-ready');
    nodes.forEach(function (node) { node.classList.add('pg-v33-reveal'); });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (node) { node.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function (node) { observer.observe(node); });
  }

  function apply() {
    document.querySelectorAll('[data-pg-likeness-slider]').forEach(initLikenessSlider);
    initShelfCue();
    initReveals();
  }

  function boot() {
    apply();
    [120, 400, 900, 1800].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(apply, 0);
  });
})();
